export const PANEL_NAME = 'RSS Blaster';
export const HEADER_ICON_TOOLTIP_TEXT = `RSS Blaster reads from your RSS feed and sends updates to your contacts
whenever there's a new post!`;
export const ADD_FEED_TEXT = 'New RSS Blaster';
export const DEFAULT_FEED_NAME = 'Untitled RSS Blaster 1';
export const CONFIRM_DELETE_ENTITY_TEXT = 'Delete RSS Blaster?';
export const CREATE_NEW_ENTITY = 'Create a new RSS Blaster';
export const NAME_ERROR = 'Name is required';
export const URL_ERROR = 'RSS Feed is required';
export const AUDIENCE_ERROR = 'Audience is required';
export const TOGGLE_ERROR = 'Fix errors before activating your feed';
export const DEFAULT_DESCRIPTION_LABEL = 'Read more';
export const DEFAULT_LINK_LABEL = 'Full story';
